export default __webpack_public_path__ + "static/media/colors-1920w.7ecd4e86.webp";